import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PLAYER_INFO_PANEL_BACKGROUND_COLOR } from '../../styles/colors';
import { range } from '../../utils/utils';
const MAX_SCORE = 5;
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  gap: 1px;
`;
const BASE_SQUARE_CSS = css `
  background-color: ${PLAYER_INFO_PANEL_BACKGROUND_COLOR};
  border: 2px solid ${PLAYER_INFO_PANEL_BACKGROUND_COLOR};
  border-radius: 5px;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
`;
export const PlayerStyleMeterDisplay = ({ score, color, label }) => {
    const ariaLabel = `${label}: ${score}/${MAX_SCORE}`;
    return (_jsx("div", { css: CONTAINER_CSS, "aria-label": ariaLabel, children: range(MAX_SCORE).map((i) => (_jsx("div", { css: BASE_SQUARE_CSS, style: score > i
                ? {
                    backgroundColor: color
                }
                : undefined }, i))) }));
};
